import { atom } from 'jotai';

type _OpaPermissionsState = {
  data: string[] | null;
  error: Error | null;
  isFetching: boolean;
};

export const initialOpaPermissionsState: _OpaPermissionsState = {
  data: null,
  error: null,
  isFetching: false,
};

export const authenticationOpaPermissionsAtom = atom<_OpaPermissionsState>(initialOpaPermissionsState);

export const resetAuthenticationAtom = atom(null, (_get, set) => {
  set(authenticationOpaPermissionsAtom, initialOpaPermissionsState);
});
